const config = [
  { propName: 'createJob', reducerName: 'createJob' },
  { propName: 'updateJob', reducerName: 'updateJob' },
  { propName: 'searchTerm', reducerName: 'searchTerm' },
  { propName: 'filters', reducerName: 'filters' },
  { propName: 'page', reducerName: 'page' },
  { propName: 'sort', reducerName: 'sort' },
  { propName: 'currentView', reducerName: 'currentView' },
  { propName: 'getAllJobs', reducerName: 'getAllJobs' },
  { propName: 'jobOffices', reducerName: 'getAllOffices' },
  { propName: 'jobDepartments', reducerName: 'getAllDepartments' },
];

export const getAtsJobs = (state) => {
  const atsJob = {};

  config.forEach(({ propName, reducerName }) => {
    atsJob[propName] = state?.atsJobs?.[reducerName];
  });

  return atsJob;
};
